import { useEffect } from 'react'

export const useBlockPageOverflow = () => {
  useEffect(() => {
    document.documentElement.style.overflow = 'hidden'

    return () => {
      document.documentElement.style.overflow = ''
    }
  }, [])
}
